import { render, staticRenderFns } from "./ChargebackStatistics.vue?vue&type=template&id=bde6430c&"
import script from "./ChargebackStatistics.vue?vue&type=script&lang=js&"
export * from "./ChargebackStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports